// --------------------------------------------------------------------------
// exhibitsDate.js
// --------------------------------------------------------------------------
// 
// --------------------------------------------------------------------------

RN.exhibitsDate = function() {

  'use strict';

  var calendar,
      open, 
      arrows;

  function init() {
    open = false;
    byBehaviour('exhibits-date').on('click', toggleCalendar);
    calendar = byElement('exhibits-date-calendar');
  }

  function toggleCalendar() {
    var trigger = $(this);
    arrows = arrows || calendar.find('.slick-arrow');

    if (open){
      closeCalendar();
    }
    else{
      openCalendar();
      positionCalendar(trigger);
    }

    return false;
  }

  function openCalendar(){
    calendar.removeClass('exhibits-date__calendar--hidden');
    $(window)
        .on('resize', function(e){
          closeCalendar(e)})
        .on('click', function(e){
          closeCalendar(e)});

    open = true;
  }

  function positionCalendar(trigger){
    var buttonPos = trigger.offset(),
        buttonWidth = trigger.outerWidth(),
        windowWidth = $(window).width();

    if(buttonPos.left < 50){
      calendar.addClass('exhibits-date__calendar--left');
    }
    else if (buttonPos.left > (windowWidth - 270)) {
      calendar.addClass('exhibits-date__calendar--right');
    }
    else {
      calendar.addClass('exhibits-date__calendar--centered');
    }
  }

  function closeCalendar(e){
    arrows = arrows || calendar.find('.slick-arrow');

    if(!($(e.target).hasClass('slick-arrow'))){
      $(window)
          .off('resize', closeCalendar)
          .off('click', closeCalendar);

      calendar.addClass('exhibits-date__calendar--hidden').removeClass('exhibits-date__calendar--left exhibits-date__calendar--right exhibits-date__calendar--centered');
      open = false;
    }
  }

  return {
    init: init
  };

}();